<p-confirmDialog></p-confirmDialog>
<h1>Donation Search</h1>
<p-toast></p-toast>
<div class="grid mb-5">
    <div class="col-12 sm:col-6 xl:col-4 align-items-center">
        <p-inputGroup>
            <input [(ngModel)]="filterValue.value" type="text"   placeholder="Quick Search..." pInputText  (input)="filterChanged()" class="input-quickfind" />
            <button type="button" pButton icon="pi pi-search" class="btn-quickfind" (click)=" searchClicked =true ; onPageSearch()" data-cy="btn-quickfind"></button>
        </p-inputGroup>
    </div>
    <div class="col-12 sm:col-6 xl:col-8 align-items-center sm:text-right">
        <rc-generic-button 
            label="Add New Donation"
            id="button-add-donor"
            level="secondary"
            size="large"
            (click)="onAddDonation()"
            data-cy="btn-add-donation"/>
    </div>
</div>

<p-card>
    <div id="search-column-toggle" class="flex vertical">
        <button class="btn-toggle-expand {{ isExpanded ? 'icon-minimize' : 'icon-expand' }}"
            (click)="toggleSelectedLabels()">
        </button>
        <p-multiSelect [group]="true" [options]="groupedOptions" [(ngModel)]="selectedColumns"
            optionLabel="displayColumn" optionGroupLabel="label" optionGroupChildren="items"
            [maxSelectedLabels]="maxSelectedLabels" [selectedItemsLabel]="'{0} items selected'" display="chip"
            placeholder="Choose Columns" id="multi-select-columns" data-cy="multi-select-columns" class="multi-select-columns expand-icon"
            scrollHeight="300px" [ngClass]="{'expanded': isExpanded, 'collapsed': !isExpanded}">
        </p-multiSelect>
    </div>

    <div class="search-actions grid py-2">
        <div class="col text-left">
            <p-button label="Export" icon="fa-sharp fa-light fa-download" (onClick)="onExportToExcel()"
                id="button-export" severity="secondary" [outlined]="true" styleClass="my-1" [disabled]="hasNoResults()"
                class="ml-0" data-cy="btn-export"></p-button>
        </div>
        <div class="top-paginator" *ngIf="!hasNoResults()">
            <div class="mb-3">
                <p-button type="button" icon="pi pi-chevron-left" styleClass="p-button-text mr-1 grey-text-button"
                    (onClick)="pageBack()" data-cy="btn-back"/>
                <p-button type="button" icon="pi pi-chevron-right" styleClass="p-button-text ml-1 grey-text-button"
                    (onClick)="pageForward()" data-cy="btn-forward"/>
            </div>
        </div>
        <div class="col text-right">
            <rc-generic-button label="Clear All" id="button-clear-filters" iconImg="clear-filter" borderStyle="outline"
                (click)="resetFilters()" [classes]="['my-1']" [disabled]="!isFilterActive" data-cy="btn-clear"/>
            <rc-generic-button label="Search" id="button-search" iconImg="search" (click)="onSearch(); searchClicked=true;"
                [classes]="['my-1 ml-1']" data-cy="btn-search"/> 
        </div>
        <p-menu #menu2 [popup]="true" [model]="selectedOptions"></p-menu>
    </div>

    <div style="width: 100%; min-height: 22rem;">
        <p-table
            #resultstable
            [scrollable]="true"
            selectionMode="multiple"
            [(selection)]="selectedRows"
            [paginator]="!hasNoResults()"
            [reorderableColumns]="true"
            scrollHeight="flex"
            [value]="rawData||[]"
            [columns]="selectedColumns"
            [rows]="10"
            [rowsPerPageOptions]="[10, 25, 50, 100]"
            (onPage)="pageChange($event)"
            [responsiveLayout]="'scroll'"
            (onFilter)="onTableFilter($event)"
            styleClass="rc-datatable-outlined first-col-border last-col-border"
            data-cy="table-data">

            <ng-template pTemplate="header" let-columns id="header-filters">
                <tr>
                    <th pFrozenColumn>
                    </th>
                    <ng-container *ngFor="let col of columns">
                        <th *ngIf="col.visible" pReorderableColumn [attr.data-cy]="'column-header-' + col.columnName" style="vertical-align: top;" nowrap
                            pSortableColumn={{col.columnName}} id="column-{{col.columnName}}">
                            <div class="sortable-title">
                                <div class="column-title">{{col.displayColumn}}</div>
                                <p-sortIcon field={{col.columnName}} style="cursor: pointer;" id="sort-icon-{{col.columnName}}" />
                            </div>
                        </th>
                    </ng-container>
                    <th alignFrozen="right" pFrozenColumn class="text-center">
                        <div class="column-title">Actions</div>
                    </th>
                </tr>
                <tr>
                    <th pFrozenColumn>
                    </th>
                    <ng-container *ngFor="let col of columns">
                        <th *ngIf="col.visible">
                        <div *ngIf="col.displayColumnType && col.displayColumnType.columnType === 'StatesMultiSelect'"
                             [attr.data-cy]="'filter-column-' + getSanitizedColumnName(col)">
                            <p-columnFilter field="State" matchMode="in" [showMenu]="false">
                                <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                                    <p-multiSelect [(ngModel)]="selectedStates" [options]="states"
                                        placeholder="Please Select" 
                                        optionValue="value" optionLabel="value" [maxSelectedLabels]="1" appendTo="body"
                                        [displaySelectedLabel]="true" emptyMessage="No states found"
                                        [selectedItemsLabel]="'{0} items selected'"
                                        (onChange)="filterChanged()">
                                        <!-- <ng-template let-option pTemplate="item">
                                            <div class="inline-block vertical-align-middle">
                                                <span class="ml-1 mt-1">
                                                    {{ option.value }}
                                                </span>
                                            </div>
                                        </ng-template> -->
                                    </p-multiSelect>
                                </ng-template>
                            </p-columnFilter>
                        </div>
                        <div *ngIf="col.displayColumnType && col.displayColumnType.columnType === 'FundraiserMultiselect'"
                             [attr.data-cy]="'filter-column-' + getSanitizedColumnName(col)">
                            <p-multiSelect [options]="fundraisers" optionLabel="value" optionValue="key"
                                [(ngModel)]="selectedFundraisers" placeholder="Please Select"
                                [maxSelectedLabels]="1" appendTo="body" [displaySelectedLabel]="true"
                                emptyMessage="No Fundraisers found"
                                [selectedItemsLabel]="'{0} items selected'" (onChange)="filterChanged()"></p-multiSelect>
                        </div>
                        <div *ngIf="col.displayColumnType && col.displayColumnType.columnType === 'EventsMultiselect'"
                             [attr.data-cy]="'filter-column-' + getSanitizedColumnName(col)">
                            <p-multiSelect [options]="events" optionLabel="value" optionValue="key"
                                [(ngModel)]="selectedEvents" placeholder="Please Select" [maxSelectedLabels]="1"
                                appendTo="body" [displaySelectedLabel]="true" emptyMessage="No Events found"
                                [selectedItemsLabel]="'{0} items selected'" (onChange)="filterChanged()"></p-multiSelect>
                        </div>
                        <div *ngIf="col.displayColumnType && col.displayColumnType.columnType === 'SourcesMultiselect'"
                             [attr.data-cy]="'filter-column-' + getSanitizedColumnName(col)">
                            <p-multiSelect [options]="sources" optionLabel="value" optionValue="key"
                                [(ngModel)]="selectedSources" placeholder="Please Select" [maxSelectedLabels]="1"
                                appendTo="body" [displaySelectedLabel]="true" emptyMessage="No Sources found"
                                [selectedItemsLabel]="'{0} items selected'" (onChange)="filterChanged()"></p-multiSelect>
                        </div>
                        <div *ngIf="col.displayColumnType && col.displayColumnType.columnType === 'FundCodesMultiSelect'"
                             [attr.data-cy]="'filter-column-' + getSanitizedColumnName(col)">
                            <p-multiSelect [options]="fundCodes" optionLabel="value" optionValue="key"
                                [(ngModel)]="selectedFundCodes" placeholder="Please Select" [maxSelectedLabels]="1"
                                appendTo="body" [displaySelectedLabel]="true" emptyMessage="No FundCodes found"
                                [selectedItemsLabel]="'{0} items selected'" (onChange)="filterChanged()"></p-multiSelect>
                        </div>
                        <div *ngIf="col.displayColumnType && col.displayColumnType.columnType === 'StatusMultiSelect'"
                             [attr.data-cy]="'filter-column-' + getSanitizedColumnName(col)">
                            <p-multiSelect [options]="statuses" optionLabel="value" optionValue="key"
                                [(ngModel)]="selectedStatus" placeholder="All" [maxSelectedLabels]="1" appendTo="body"
                                [displaySelectedLabel]="true" emptyMessage="No Status found"
                                [selectedItemsLabel]="'{0} items selected'" (onChange)="filterChanged()"></p-multiSelect>
                        </div>
                        <div *ngIf="col.displayColumnType && col.displayColumnType.columnType === 'ApprovalMultiSelect'"
                             [attr.data-cy]="'filter-column-' + getSanitizedColumnName(col)">
                            <p-multiSelect [options]="approvals" optionLabel="value" optionValue="key"
                                [(ngModel)]="selectedApproval" placeholder="All" [maxSelectedLabels]="1" appendTo="body"
                                [displaySelectedLabel]="true" emptyMessage="No Approvals found"
                                [selectedItemsLabel]="'{0} items selected'" (onChange)="filterChanged()"></p-multiSelect>
                        </div>
                        <div *ngIf="col.displayColumnType && (col.displayColumnType.columnType === 'TextFilter')
                        || (col.displayColumnType.columnType === 'IDFilter')" [attr.data-cy]="'filter-column-' + getSanitizedColumnName(col)">
                            <input pInputText type="text"
                                   [(ngModel)]="textFilters[col.columnName]"
                                   class="form-control"
                                   placeholder=""
                                   id="filter-{{col.columnName}}" (ngModelChange)="filterChanged()"/>
                            </div>
                        <div *ngIf="col.displayColumnType && (col.displayColumnType.columnType === 'CommonFilter')"
                             [attr.data-cy]="'filter-column-' + getSanitizedColumnName(col)">
                            <p-columnFilter type="text" [matchMode]="getMatchMode(col.displayColumnType.columnType)"
                                [matchModeOptions]="defaultCmmonFilters" field={{col.columnName}} placeholder="All"
                                ariaLabel="Filter Name" id="filter-{{col.columnName}}" (onModelChange)="filterChanged()"/>
                        </div>
                        <div *ngIf="col.displayColumnType && col.displayColumnType.columnType === 'NoFilter'">
                        </div>
                        <div
                            *ngIf="col.displayColumnType && col.displayColumnType.columnType !== 'ApprovalMultiSelect' 
                            && col.displayColumnType.columnType !== 'StatusMultiSelect' 
                            &&col.displayColumnType.columnType !== 'FundCodesMultiSelect'
                            &&col.displayColumnType.columnType !== 'StatesMultiSelect' 
                            &&col.displayColumnType.columnType !== 'NoFilter' 
                            &&col.displayColumnType.columnType !== 'CommonFilter' 
                            &&col.displayColumnType.columnType !== 'TextFilter' 
                            &&col.displayColumnType.columnType !== 'IDFilter' 
                            &&col.displayColumnType.columnType !== 'SourcesMultiselect' 
                            &&col.displayColumnType.columnType !== 'EventsMultiselect' 
                            &&col.displayColumnType.columnType !== 'FundraiserMultiselect' 
                            && col.displayColumnType.columnType !== 'HoldMultiSelect'">
                            <rc-table-filter [filterModel]="col.filterModel" (modelChange)="col.filterModel = $event" />
                        </div>
                    </th>
                    </ng-container>
                    <th alignFrozen="right" pFrozenColumn [frozen]="balanceFrozen">
                    </th>
                </tr>
            </ng-template>

            <ng-template pTemplate="body" let-rowData let-columns="columns" let-index="rowIndex">
                <tr [ngClass]="isDisabledCheckbox(rowData) ? 'disabled-row' : ''">
                    <td pFrozenColumn>
                    </td>
                    <ng-container *ngFor="let col of columns">
                        <td class="text-center"  *ngIf="col.visible" nowrap>
                            <span *ngIf="col.columnName === 'DonationID'">
                                <a [routerLink]="['/vortex/donations/donation-card']" [queryParams]="{ fromSearchDonorID: rowData['DonorID'], donationId: rowData[col.columnName], splitId: rowData['SplitID']  }" *ngIf="!showInDialog; else hideDonationIDBlock">
                                {{ rowData[col.columnName] }}
                                </a>
                                <ng-template #hideDonationIDBlock>
                                    <a href="javascript:void(0)" (click)= "openAddDonationCardDialog( rowData[col.columnName])"> 
                                        {{ rowData[col.columnName] }}
                                    </a>
                                </ng-template>
                            </span>
                            <span *ngIf="col.columnName === 'DonorID'">
                                <a [routerLink]="['/vortex/donors/card', rowData[col.columnName]]" *ngIf="!showInDialog; else hideDonorIDBlock">
                                {{ rowData[col.columnName] }}
                                </a>
                                <ng-template #hideDonorIDBlock>
                                    <a href="javascript:void(0)" (click)= "openAddDonorDialog( rowData[col.columnName])"> 
                                    {{ rowData[col.columnName] }}
                                    </a>
                                </ng-template>
                            </span>
                            <span *ngIf="col.columnName==='Amount'">
                                {{rowData[col.columnName] | currency:'USD':'symbol' }}
                              
                            </span>
                            <span
                                *ngIf="!['DonorID','DonationID', 'ExpenseRequestId', 'FileName', 'ExpenseStatus','MyApproval','Amount'].includes(col.columnName)">
                                <span *ngIf="col.columnName.toLowerCase().includes('date')">
                                    {{ rowData[col.columnName] ? (rowData[col.columnName] | date: 'MM/dd/YYYY') : '-' }}
                                </span>
                                <span *ngIf="!col.columnName.toLowerCase().includes('date')">
                                    {{ rowData[col.columnName] || '-' }}
                                </span>
                            </span>
                        </td>
                    </ng-container> 
                    <td alignFrozen="right" pFrozenColumn style="white-space: nowrap; padding: 1rem 0.5rem;" class="text-center">
                        <rc-generic-button label="Edit"
                                           iconImg="cog"
                                           iconColor="teal-light"
                                           [isIconOnly]="true"
                                           [classes]="['mx-1']"
                                           (click)= "openEditDonationDialog(rowData)"
                                           data-cy="btn-edit"/>
                          
            
                        <rc-generic-button label="Delete"
                                           iconImg="trash"
                                           iconColor="red-light"
                                           [isIconOnly]="true"
                                           [classes]="['mx-1']"
                                           (click)= "deleteDonation(rowData)"
                                           data-cy="btn-delete"/>
                      </td>
                </tr>
            </ng-template>

            <ng-template pTemplate="emptymessage">
                <tr *ngIf="!showLoading">
                    <td [attr.colspan]="selectedColumns.length + 2" class="no-data-message">
                        {{NoDataMessage}}
                    </td>
                </tr>
            </ng-template>
        </p-table>

        <div ngClass="medium loader-wrapper" *ngIf="showLoading">
            <rc-loading-spinner></rc-loading-spinner>
        </div>
 </div>
</p-card>

<!-- Donation Card MODAL -->
<p-dialog [(visible)]="showAddDonationCardDialog"
    [modal]="true"
    [maximizable]="true"
    header="Donation Card"
    styleClass="p-dialog-static p-dialog-lg fadeinright animation-duration-300">
    
    <app-donation-card [fromSearchDonorID]="selectedDonationId" [isDockable]="false" [isModalPopup] ="true" ></app-donation-card>

    <ng-template pTemplate="footer">
        <rc-generic-button label="Close" (click)="showAddDonationCardDialog = false"> </rc-generic-button>
    </ng-template>
</p-dialog>

<!-- Donor Card MODAL -->
<p-dialog [(visible)]="showDialog"
    [modal]="true"
    [maximizable]="true"
    header="Donor Card"
    styleClass="p-dialog-static p-dialog-lg fadeinright animation-duration-300">
    
    <app-donor-card [fromSearchDonorID]="selectedDonorId" [isDockable]="false" [isModalPopup]="true"></app-donor-card>
    
    <ng-template pTemplate="footer">
        <rc-generic-button label="Close" (click)="showDialog = false"> </rc-generic-button>
    </ng-template>
</p-dialog>
